// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerNilDeals_block__XZlp1","wrapper":"PlayerNilDeals_wrapper__qS3Np"};